import { FC } from "react";
import { settings } from "../../../../shim/jsbridge";
import { ReportSummary } from "../../@types";
import { COMPONENT_IDS } from "../../consts";
import { PDFExport } from "./@types/PDFExport";
import {
  DynamicAnalysisInsightsCard,
  EmailCard,
  LLMSummaryCard,
  MitreAttackCard,
  NetworkReferencesCard,
  SampleInformationCard,
  SimpleRelationshipsGraphCard,
  StaticAnalysisInsightsCard,
  ThreatIntelligenceCard,
  YaraMatchesCard,
  SourcesCard
} from "./cards";
import SampleDescriptionCard from "./cards/description/SampleDescriptionCard";
import { getHasThreatName, getIsEmail } from "./utils";

export const ANALYSIS = {
  RLAA: "Auxiliary Analysis",
  CAPE: "CAPE",
  CISCO_SMA: "Cisco SMA",
  MEDIAADDRESS: "Computer Vision Analysis",
  CUCKOO: "Cuckoo",
  FIREEYE: "FireEye",
  JOE: "Joe",
  RLCS: "RL Cloud Sandbox",
  SOURCES: "Sources",
  TICORE: "Static Analysis",
  VMRAY: "VMRay"
} as const;

export const MEDIAADDRESS_FORMAT = {
  QR: "QR",
  OCR: "OCR"
};

export const INITIAL_CLASSIFICATION_COUNT = {
  malicious: 0,
  suspicious: 0,
  goodware: 0,
  unknown: 0,
  total: 0
} as const;

export const INITIAL_STATS = {
  hasMoreData: false,
  total: 0,
  [ANALYSIS.RLCS]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.RLAA]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.CAPE]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.CISCO_SMA]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.CUCKOO]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.FIREEYE]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.JOE]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.MEDIAADDRESS]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.SOURCES]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.TICORE]: INITIAL_CLASSIFICATION_COUNT,
  [ANALYSIS.VMRAY]: INITIAL_CLASSIFICATION_COUNT
};

export const SORT_ORDER: Record<string, number> = {
  malicious: 1,
  suspicious: 2,
  unknown: 3,
  goodware: 4
};

export const COMPONENTS_MAP: Record<
  string,
  { Component: FC<PDFExport>; filterFn?: (report?: ReportSummary) => boolean }
> = {
  [COMPONENT_IDS.SAMPLE_INFORMATION]: { Component: SampleInformationCard },
  [COMPONENT_IDS.SOURCES]: { Component: SourcesCard },
  [COMPONENT_IDS.SAMPLE_DESCRIPTION]: { Component: SampleDescriptionCard },
  [COMPONENT_IDS.RELATIONSHIP_GRAPH]: {
    Component: SimpleRelationshipsGraphCard
  },
  [COMPONENT_IDS.MITRE]: { Component: MitreAttackCard },
  [COMPONENT_IDS.ATTRIBUTION_DATA]: {
    Component: ThreatIntelligenceCard,
    filterFn: report => getHasThreatName(report?.threat_name)
  },
  [COMPONENT_IDS.NETWORK_REFERENCES]: { Component: NetworkReferencesCard },
  [COMPONENT_IDS.STATIC_ANALYSIS_INSIGHTS]: {
    Component: StaticAnalysisInsightsCard
  },
  [COMPONENT_IDS.DYNAMIC_ANALYSIS_INSIGHTS]: {
    Component: DynamicAnalysisInsightsCard
  },
  [COMPONENT_IDS.YARA_MATCHES]: {
    Component: YaraMatchesCard
  },
  [COMPONENT_IDS.EMAIL]: {
    Component: EmailCard,
    filterFn: report => getIsEmail(report?.file_type)
  },
  [COMPONENT_IDS.LLM_SUMMARY]: {
    Component: LLMSummaryCard,
    filterFn: () => !!settings.FEATURE_LLM_SUMMARY
  }
} as const;
